module.exports = __webpack_public_path__ + "static/media/tech-showcase-crop.41433923.png";